import styled from 'styled-components'

// ─────────────────────────────────────────────────────────────────────────────
// PÁGINA PÚBLICA "/conteudos" — vitrine completa para visitantes (não logados).
// Mostra carrossel + categorias + coleções (lendo do backend público). Qualquer
// clique para assistir leva aos planos.
// ─────────────────────────────────────────────────────────────────────────────
export const PublicPage = styled.div.attrs({
})`
    min-height: 100vh;
    background: var(--darkprimary-color);
    padding-bottom: 40px;
`;

export const PublicTopbar = styled.div.attrs({
})`
    position: sticky;
    top: 0;
    z-index: 30;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 12px 24px;
    background: var(--primary-color);
    box-shadow: 0 2px 10px rgba(0,0,0,.18);

    @media(max-width: 600px){
        padding: 10px 14px;
    }
`;

export const TopLogo = styled.img.attrs({
    src: '/icons/logo.svg',
    alt: 'JoinKids'
})`
    height: 40px;
    cursor: pointer;

    @media(max-width: 600px){
        height: 34px;
    }
`;

export const TopActions = styled.div.attrs({
})`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const GhostBtn = styled.button.attrs({
})`
    background: transparent;
    color: var(--white-color);
    border: 1.5px solid rgba(255,255,255,.7);
    border-radius: 999px;
    padding: 9px 20px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;

    &:hover{ background: rgba(255,255,255,.12); }

    @media(max-width: 600px){
        padding: 8px 14px;
        font-size: 14px;
    }
`;

export const SolidBtn = styled.button.attrs({
})`
    background: var(--secondary-color);
    color: var(--white-color);
    border: none;
    border-radius: 999px;
    padding: 10px 22px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;

    &:hover{ filter: brightness(1.06); }

    @media(max-width: 600px){
        padding: 9px 16px;
        font-size: 14px;
    }
`;

export const HelperBar = styled.div.attrs({
})`
    text-align: center;
    color: var(--white-color);
    background: rgba(0,0,0,.18);
    padding: 10px 16px;
    font-size: 14px;
`;

export const PublicCTA = styled.div.attrs({
})`
    margin: 44px auto 0;
    max-width: 680px;
    text-align: center;
    color: var(--white-color);
    padding: 28px 22px;

    h3 { font-size: 24px; margin: 0 0 8px; font-weight: 800; }
    p { font-size: 16px; opacity: .9; margin: 0 0 18px; line-height: 1.4; }
`;

export const CenterWrap = styled.div.attrs({
})`
    display: flex;
    justify-content: center;
`;
